// Mirrors public.archive_job_status_enum; values match its labels exactly. REQUESTED, PROCESSING and
// STALLED are the live set uidx_archive_jobs_in_flight allows one of per configuration.
export enum ArchiveJobStatusEnum {
  REQUESTED = 'REQUESTED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  STALLED = 'STALLED',
  SKIPPED = 'SKIPPED',
}
